import { Component, Input, OnInit } from '@angular/core';
import { SystemEventService } from 'src/app/modules/instance/services/system-event.service';
import { SystemEventParentType } from 'src/app/shared/enums/system-event-parent-type';
import IProcessEventsSequenceAnalyzerStatistic = ZoningAPI.IProcessEventsSequenceAnalyzerStatistic;
import { map } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-update-process-events-statistic-button',
    templateUrl: './update-process-events-statistic-button.component.html',
    styleUrls: ['./update-process-events-statistic-button.component.scss']
})
export class UpdateProcessEventsStatisticButtonComponent implements OnInit {
    @Input()
    stateEnv: string;

    @Input()
    processId: string;

    @Input()
    updateDataHandler: (data: IProcessEventsSequenceAnalyzerStatistic) => void;

    constructor(private readonly systemEventService: SystemEventService) {}

    ngOnInit(): void {}

    updateProcessEventsStatistic() {
        if (!this.stateEnv || !this.processId) {
            return;
        }
        return this.systemEventService
            .getSystemEventsStatistic(this.stateEnv.toLocaleLowerCase(), this.processId, SystemEventParentType.PROCESS)
            .pipe(
                map((data: IProcessEventsSequenceAnalyzerStatistic) => {
                    this.updateDataHandler(data);
                })
            );
    }
}
